var ___EXPOSE_LOADER_IMPORT___ = require("-!./debug-require.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../../srv/zulip-npm-cache/08ad4a873715948c3bfaf2cb931697eb24fd5622/node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["require"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["require"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
